// Custom components
import React from "react";

function TextField(props) {
  const { label,value,onChange, id, extra, placeholder, cols, rows, state, disabled } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className="ml-3 mb-2 text-sm font-bold text-navy-700 dark:text-slate-200"
      >
        {label}
      </label>
      <div>
        <textarea
          cols={cols}
             value={value}       // controlled value here
        onChange={onChange}
          rows={rows}
          placeholder={placeholder}
          className={`flex w-full items-center justify-center rounded-xl border bg-white pl-3 pt-3 text-sm outline-none ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-slate-800/50 dark:text-slate-400 dark:placeholder:!text-slate-600"
              : state === "error"
              ? "!border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400 dark:bg-slate-800/50"
              : state === "success"
              ? "!border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400 dark:bg-slate-800/50"
              : "border-gray-200 dark:!border-slate-600 dark:bg-slate-800/50 dark:text-slate-100 dark:placeholder:text-slate-500"
          }`}
          name={id}
          id={id}
        />
      </div>
    </div>
  );
}

export default TextField;
